import React from "react";
import "./App.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import FeatureGrid from "./components/FeatureGrid";
import ProcessSection from "./components/ProcessSection";
import TechnologySection from "./components/TechnologySection";
import ForChefsSection from "./components/ForChefsSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="app" id="top">
      <Navbar />
      <main>
        <Hero />
        <FeatureGrid />
        <ProcessSection />
        <TechnologySection />
        <ForChefsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
